<template>
  <div class="detail">
    <!--项目详情-->
    <div class="order__itemBox mb_10">
      <div class="storeList flex_center radius5">
        <div class="storeList__img itemList__img"><img :src="order_data.service_thumb" alt=""></div>
        <div class="storeList__content">
          <div>{{order_data.servicetitle}}</div>
          <div class="col_999 fs_12 mb_5 one">{{order_data.service_desc}}</div>
          <div class="itemList_price fs_12"><span>¥{{order_data.service_price}}</span>{{order_data.service_itemtime}}分钟/次</div>
        </div>
      </div>
    </div>
    <div class="order_info">
      <p><label>订单编号：</label><span>{{order_data.ordersn}}</span></p>
      <p><label>下单时间：</label><span>{{order_data.createtime}}</span></p>
      <p><label>订单金额：</label><span class="col_E97620">{{order_data.price}}</span></p>
      <p><label>订单状态：</label>
      <span v-if="order_data.status==0">待付款</span>
      <span v-if="order_data.status==1">待接单</span>
      <span v-if="order_data.status==2">待服务</span>
      <span v-if="order_data.status==3">已核销</span>
      <span v-if="order_data.status==4">已取消</span>
      <span v-if="order_data.status==5">已服务</span>
      <span v-if="order_data.status==-1">已取消</span>
      </p>
      <div v-for="(tech_item1,tech_index1) in tech" :key="tech_index1">
          <p v-if="tech_item1.service_status==4"><label>核销时间：</label><span >{{tech_item1.finishtime}}</span></p>
          <p v-if="tech_item1.service_status==4"><label>核销人员：</label><span>{{tech_item1.name}}</span></p>
      </div>
      
      <p v-if="order_data.status !=3"><label><span >{{order_data.distance_text}}</span></label><span class="col_333" v-if="order_data.status==3">已过期</span><span v-else>{{order_data.distance_service}}</span></p>

    </div>
    <div class="order_info">
      <p><label>服务门店：</label><span>{{store.storename}}</span></p>
      <p><label>服务人数：</label><span>{{order_data.total}}位</span></p>
      <p v-for="(tech_item,tech_index) in tech" :key="tech_index">
        <label>服务技师：</label><span>{{tech_item.name}}</span>
         <a v-if="tech_item.refuse==2" class="tech_none" style="color: #969799;">（拒绝接单）</a>
      </p>
      <p><label>服务时间：</label><span>{{order_data.starttime}}</span></p>
      <p><label>联系人姓名：</label><span>{{order_data.realname}}</span></p>
      <p><label>联系人手机号：</label><span>{{order_data.mobile}}</span></p>
    </div>
  </div>
</template>

<script>
export default {
  name: "store_orderDetails",
  components: {},
  data() {
    return {
      id:0,
      //项目列表
      order_data:[],
      store:[],
      tech:[]
    };
  },
  created(){
    this.id  = this.$route.query.id
  
    this.get_order_detail();
  },
  
  methods: {
    get_order_detail(){
      this.axios({
          url: this.api.store.store_order_detail,
          data: {id:this.id}
        }).then(res => {
          if (res.error === 0) {
           this.order_data = res.order
           this.store = res.store
           this.tech = res.tech
          }
        });
    }
  }
};
</script>
<style scoped>
  @import '../../../assets/css/store.css';   /*门店样式*/
  @import '../../../assets/css/item.css';   /*服务项目*/
  .order__itemBox{
    background: #45B9BC;
    padding: .75rem .5rem;
  }
  .storeList{
    margin-bottom: 0;
  }
  .order_info {
    background: #fff;
    margin-bottom: .25rem;
    padding: .5rem .75rem;
    font-size: .7rem;
    color: #333;
  }
  .order_info p{
    padding: .1rem 0;
  }
  .order_info p>span{
    color: #999;
    display: inline-block;
    margin-left: .5rem;
  }
</style>



// WEBPACK FOOTER //
// src/views/store/order/store_orderDetails.vue